<ion-grid>
  <section class="filters">
    <ion-row class="container">
      <ion-col size="12">
        <ion-card class="filters__card">
          <ion-card-header class="filters__card__header">
            <ion-card-title>Listado usuarios</ion-card-title>
          </ion-card-header>
          <form autocomplete="off" [formGroup]="filterUserForm">
            <ion-row class="filters__card__row">
              <ion-col size="12" sizeMd="4" class="filters__card__col">
                <app-input
                  [formGroup]="filterUserForm"
                  label="Nombre y apellidos"
                  formControlName="userEmail"
                  type="selectwithsearch"
                  [displayValue]="getName(filterUserForm.get('userEmail')?.value)"
                  [options]="filterNameList"
                  [required]="false"
                  [defaultValueSelect]="defaultValueSelect"
                />
              </ion-col>
              <ion-col size="12" sizeMd="4" class="filters__card__col">
                <app-input
                  [formGroup]="filterUserForm"
                  label="Empresa"
                  formControlName="company"
                  type="selectwithsearch"
                  [displayValue]="getCompany(filterUserForm.get('company')?.value)"
                  [options]="filterCompanyList"
                  [required]="false"
                  [defaultValueSelect]="defaultValueSelect"
                />
              </ion-col>
              <ion-col size="12" sizeMd="4" class="filters__card__col">
                <app-input
                  [formGroup]="filterUserForm"
                  label="Estado"
                  formControlName="state"
                  type="select"
                  [options]="stateCompanyList"
                  [required]="false"
                  [defaultValueSelect]="defaultValueSelect"
                />
              </ion-col>
            </ion-row>
          </form>
        </ion-card>
      </ion-col>
    </ion-row>
  </section>
  <section class="users">
    <ion-row class="container">
      <ion-col size="12">
        @if (usersExt) { @if (usersExt.length > 0) {
        <ion-card class="users__card">
          <ion-grid class="users__table">
            <ion-row
              class="users__table__row users__table--header ion-align-items-center"
            >
              <ion-col class="ion-padding" size="2"
                ><strong>Nombre y apellidos</strong></ion-col
              >
              <ion-col class="ion-padding" size="3"
                ><strong>Email</strong></ion-col
              >
              <ion-col class="ion-padding" size="2"
                ><strong>Empresa</strong></ion-col
              >
              <ion-col class="ion-padding" size="1"
                ><strong>Fecha de registro</strong></ion-col
              >
              <ion-col class="ion-padding" size="1"
                ><strong>Estado</strong></ion-col
              >
              <ion-col class="ion-padding" size="1"><strong
                >Fecha de estado</strong></ion-col>
              <ion-col class="ion-padding" size="1"></ion-col>
              <ion-item-divider
                class="divider divider--header"
              ></ion-item-divider>
            </ion-row>
            @for (req of usersExt; track $index) {
            <ion-row class="ion-align-items-center users__table__row">
              <ion-col class="ion-padding col-text-break" size="2">{{
                req.firstName
              }} {{ req.lastName }}</ion-col>
              <ion-col class="ion-padding col-text-break" size="3">{{ req.email }}</ion-col>
              <ion-col class="ion-padding col-text-break" size="2">{{ req.company }}</ion-col>
              <ion-col class="ion-padding" size="1">{{
                req.createDate | date : 'dd/MM/yyyy'
              }}</ion-col>
              <ion-col class="ion-padding" size="1">{{
                getState(req.state)
              }}</ion-col>
              <ion-col class="ion-padding" size="1">{{ req.lastDateUpdated | date : 'dd/MM/yyyy' }}</ion-col>
              <ion-col class="ion-padding" size="1">
                @if(req.state == 2) {
                <ion-icon
                  (click)="openOptionsModal($event, req.email)"
                  class="custom-icon-table icon icon-dots-vertical"
                  aria-label="Ver más opciones de gestión de usuario"
                  role="button"
                ></ion-icon
                >}
              </ion-col>
              <ion-item-divider
                class="divider divider--body"
              ></ion-item-divider>
            </ion-row>
            } @if (usersExt && usersExt.length < 1) {
            <ion-row class="ion-align-items-center users__table__row">
              <ion-col class="ion-padding" size="4">No existen datos</ion-col>
            </ion-row>
            }
          </ion-grid>
          @if (hasMoreItems) {
          <ion-row class="ion-justify-content-center ion-padding">
            <a class="load-more-link" (click)="loadMore()">
              Ver más
            </a>
          </ion-row>
          }
        </ion-card>
        } @else {
        <app-general-error type="warning" code="no-data.users" />
        } }
      </ion-col>
    </ion-row>
  </section>
</ion-grid>
